"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_OPTIONS_UNTIL_VIRTUALIZATION = exports.DEFAULT_ITEM_HEIGHT = void 0;
const MAX_OPTIONS_UNTIL_VIRTUALIZATION = 50;

/**
 * The default height of an option. This is used for calculating styles and in virtualization.
 */
exports.MAX_OPTIONS_UNTIL_VIRTUALIZATION = MAX_OPTIONS_UNTIL_VIRTUALIZATION;
const DEFAULT_ITEM_HEIGHT = 40;
exports.DEFAULT_ITEM_HEIGHT = DEFAULT_ITEM_HEIGHT;
//# sourceMappingURL=selectConstants.js.map